var q = Object.defineProperty;
var B = (t, e, n) => e in t ? q(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var v = (t, e, n) => B(t, typeof e != "symbol" ? e + "" : e, n);
import { Component as J, createContext as g, useContext as Y, useTransition as K, useState as w, useMemo as R, useEffect as u, Suspense as P, createElement as k, StrictMode as G, forwardRef as S, useRef as X, Children as Z, isValidElement as H, useSyncExternalStore as tt } from "react";
import { CustomError as et, routerRef as nt, RouteNotFoundError as rt, createApplicationManager as ot, equalsLocation as ct, resourcesRef as $, i18nRef as it, createResourceQuery as M, createInfinitePagination as at } from "@funtech-int/rival";
import { jsx as i } from "react/jsx-runtime";
class _ extends J {
  constructor(e) {
    super(e), this.state = { error: null }, this.resetError = this.resetError.bind(this);
  }
  static getDerivedStateFromError(e) {
    return { error: e };
  }
  componentDidCatch(e, n) {
    var r, o;
    (o = (r = this.props).logError) == null || o.call(r, e, n);
  }
  resetError() {
    this.setState({ error: null });
  }
  render() {
    if (!this.state.error)
      return this.props.children;
    const e = this.props.fallback;
    return typeof e == "function" ? /* @__PURE__ */ i(
      e,
      {
        error: this.state.error,
        resetError: this.resetError
      }
    ) : e;
  }
}
const E = g(null);
E.displayName = "RouterContext";
const T = g(null);
T.displayName = "RootContext";
class z extends et {
}
v(z, "name", "ContextNotFoundError");
function x(t) {
  const e = Y(t);
  if (e == null)
    throw new z();
  return e;
}
function f() {
  return x(T);
}
function y() {
  return f().ssr;
}
function st(t) {
  const { app: e } = f();
  return e.get(t);
}
function C(t) {
  const e = st(t);
  if (!e)
    throw new Error(`Instance "${t.description}" is not found`);
  return e;
}
function d() {
  return C(nt);
}
const ut = typeof document < "u" && typeof document.startViewTransition == "function";
function lt() {
  const [, t] = K(), [e, n] = w(0), [r, o] = R(() => {
    let c, a;
    return [ut ? (m) => {
      document.startViewTransition(
        () => new Promise((I, p) => {
          c = I, a = p, t(() => {
            n((Q) => Q + 1), m();
          });
        })
      );
    } : t, () => (c && c(), a)];
  }, []);
  return u(o, [e]), r;
}
function b(t, e) {
  const n = e.matchRoute(t);
  if (!n)
    throw new rt();
  return {
    id: t.id,
    state: t.state,
    params: t.params,
    meta: n.meta,
    route: n.route,
    component: n.component,
    fallback: n.fallback
  };
}
const F = (t) => {
  const e = lt(), n = d(), r = f(), o = y(), c = typeof window < "u" ? window.location.pathname : (o == null ? void 0 : o.url.pathname) ?? "";
  n.run(c);
  const [a, s] = w(b(n.location, r.app));
  return u(() => {
    const l = n.beforeEach((m, I, p) => {
      e(p);
    }), h = n.listen(() => {
      s(b(n.location, r.app));
    });
    return () => {
      l(), h();
    };
  }, []), /* @__PURE__ */ i(E.Provider, { value: a, children: t.children });
};
F.displayName = "RouterProvider";
const ft = (t) => {
  const e = t.layout;
  return /* @__PURE__ */ i(
    T.Provider,
    {
      value: {
        app: t.appManager,
        ssr: t.ssrManager
      },
      children: /* @__PURE__ */ i(_, { fallback: t.fallback, children: /* @__PURE__ */ i(P, { children: /* @__PURE__ */ i(F, { children: /* @__PURE__ */ i(e, {}) }) }) })
    }
  );
}, N = "__APP__";
function St({
  layout: t,
  fallback: e,
  scenarios: n = []
}) {
  const r = ot();
  n.forEach((c) => {
    r.use(c);
  });
  const o = (c) => {
    if (typeof window < "u") {
      const a = window[N];
      a && r.hydrate(a);
    } else c && c.prepare(() => {
      const a = JSON.stringify(r.toJSON());
      c.addInline(`window.${N} = ${a};`);
    });
    return k(
      G,
      null,
      k(ft, {
        layout: t,
        fallback: e,
        appManager: r,
        ssrManager: c
      })
    );
  };
  return o.set = (c) => (r.set(c.ref(), () => c), o), o;
}
const A = g(null);
A.displayName = "TranslationsContext";
const V = (t) => (u(() => (t.onMount && t.onMount(), t.onUnmount), []), t.children);
function L(t) {
  const e = x(E);
  if (t && !t.is(e))
    throw new Error(`Route '${t.name}' is not matched to current location`);
  return e;
}
const Tt = S((t, e) => {
  const n = L(), r = d(), o = R(() => {
    var a;
    return {
      href: r.serialize(t.to) + ((a = t.searchParams) != null && a.size ? `?${t.searchParams.toString()}` : ""),
      onClick(s) {
        if (t.onClick ? t.onClick(s) : s.preventDefault(), s.defaultPrevented) {
          const l = t.searchParams ? { searchParams: t.searchParams } : void 0;
          r.navigate({
            to: t.to,
            replace: t.replace,
            meta: l
          });
        }
      }
    };
  }, [t.to, t.replace, t.onClick]), c = [
    t.className,
    ct(n, t.to) ? t.activeClassName : void 0
  ].join(" ");
  return /* @__PURE__ */ i(
    "a",
    {
      ref: e,
      className: c,
      title: t.title,
      href: o.href,
      onClick: o.onClick,
      children: t.children
    }
  );
}), dt = (t) => {
  const { app: e } = f(), n = e.matchError(t.error);
  if (n)
    return /* @__PURE__ */ i(
      n.component,
      {
        error: t.error,
        resetError: t.resetError
      }
    );
  throw t.error;
};
function U(t, ...e) {
  const n = X();
  return n.current === void 0 && (n.current = t(...e)), n.current;
}
function ht(t) {
  let e = {}, n = t;
  return {
    attach(r) {
      e = r;
    },
    change(r, o) {
      var c;
      (c = e.onChange) == null || c.call(e, r, o), n = o;
    },
    fetch() {
      var r;
      (r = e.onFetch) == null || r.call(e, n);
    },
    complete() {
      var r;
      (r = e.onComplete) == null || r.call(e, n);
    },
    render() {
      var r;
      (r = e.onRender) == null || r.call(e, n);
    }
  };
}
function mt() {
  const t = d(), e = U(ht, t.location);
  return u(() => {
    let n = t.location;
    t.listen(() => {
      e.change(n, t.location), n = t.location;
    });
  }, []), e;
}
const xt = (t) => {
  const e = x(E), n = mt(), r = d();
  n.attach(t);
  const o = /* @__PURE__ */ i(
    V,
    {
      onMount: n.fetch,
      onUnmount: n.complete,
      children: e.fallback ? /* @__PURE__ */ i(e.fallback, {}) : null
    }
  );
  return /* @__PURE__ */ i(
    _,
    {
      fallback: dt,
      children: /* @__PURE__ */ i(
        P,
        {
          fallback: o,
          children: /* @__PURE__ */ i(V, { onMount: n.render, children: /* @__PURE__ */ i(e.component, {}) })
        },
        r.key
      )
    },
    r.key
  );
};
function wt(t, e) {
  if (t === void 0)
    return e;
  if (t > 300 && t < 304 || t > 306 && t < 309)
    return t;
  throw new Error("Invalid <Redirect> status");
}
const It = (t) => {
  const e = d(), n = y();
  return u(() => {
    e.navigate({ to: t.to, replace: !0 });
  }, []), n && n.setRedirect({
    status: wt(t.status, 302),
    uri: e.serialize(t.to)
  }), null;
};
function Rt(t) {
  return t.type === "title";
}
const vt = (t) => {
  const e = y();
  let n = "";
  return Z.forEach(t.children, (r) => {
    var o;
    H(r) && (Rt(r) ? (n = ((o = r.props.children) == null ? void 0 : o.toString()) || "", e == null || e.setTitle(n)) : e && e.addMeta(r));
  }), u(() => {
    n && (document.title = n);
  }, [n]), null;
};
function D(t) {
  return tt(t.listen, t.get, t.get);
}
const bt = ({
  signal: t,
  fallback: e,
  force: n,
  children: r
}) => D(t) || n ? /* @__PURE__ */ i(P, { fallback: e, children: r }) : e;
function Et() {
  const [, t] = w(0);
  return () => t((e) => e + 1);
}
function O(...t) {
  const e = C($), n = Et(), r = e.acquire(t);
  return u(() => {
    const o = e.listen(r, n);
    return () => {
      o(), e.free();
    };
  }, r), e.read(r);
}
function yt() {
  return C(it);
}
const W = M({
  key(t) {
    return `component(${t.id})`;
  },
  fetch(t) {
    return t.factory();
  }
}), Ct = M({
  key(t) {
    return `translations(${t.id})/${t.locale.lang}`;
  },
  fetch(t) {
    return t.factory(t.locale);
  }
}), j = /* @__PURE__ */ (() => {
  let t = 0;
  return () => `id_${t++}}`;
})();
function Nt(t) {
  const e = j();
  return S((n, r) => {
    const [o] = O(W({
      id: e,
      factory: t
    })), c = o.default;
    return /* @__PURE__ */ i(c, { ...n, ref: r });
  });
}
function Vt(t) {
  return function(n) {
    const r = j();
    return S((o, c) => {
      const a = yt(), s = D(a.locale), [l, h] = O(
        W({
          id: r,
          factory: n
        }),
        Ct({
          id: r,
          locale: s,
          factory: t
        })
      ), m = l.default;
      return /* @__PURE__ */ i(A.Provider, { value: h.default, children: /* @__PURE__ */ i(m, { ...o, ref: c }) });
    });
  };
}
function $t() {
  const [t, e] = w();
  if (t)
    throw t;
  return e;
}
function Mt() {
  const t = C($), e = U(at, t);
  return u(e.effect, []), e;
}
function _t(t) {
  const { app: e } = f();
  return R(() => {
    const n = () => new Error(`widget: "${t.name}" is not registered`), r = e.matchWidget(t);
    return {
      get enabled() {
        return !!r;
      },
      get meta() {
        if (!r)
          throw n();
        return r.meta;
      },
      render(o, c) {
        if (!r)
          throw n();
        return k(r.component, o, c);
      }
    };
  }, [t]);
}
function zt() {
  const t = y(), e = L();
  return R(() => {
    if (typeof window < "u")
      return window.location.search ? new URLSearchParams(window.location.search) : void 0;
    if (t)
      return t.url.searchParams.size > 0 ? t.url.searchParams : void 0;
  }, [e]);
}
export {
  bt as ConditionalSuspense,
  _ as ErrorBoundary,
  vt as Head,
  V as Lifecycle,
  It as Redirect,
  ft as Root,
  T as RootContext,
  xt as Route,
  Tt as RouterLink,
  A as TranslationsContext,
  St as createApplication,
  Nt as lazy,
  Vt as lazyWithI18n,
  U as useFactory,
  Et as useForceUpdate,
  yt as useI18n,
  Mt as useInfinitePagination,
  st as useInstance,
  O as useResources,
  L as useRouteMatch,
  d as useRouter,
  y as useSSR,
  zt as useSearchParams,
  D as useSignal,
  x as useStrictContext,
  C as useStrictInstance,
  $t as useThrowError,
  lt as useViewTransition,
  _t as useWidget
};
